import {
  createFilters,
  getFixedColumns,
  getFormattedTitles,
  getHiddenColumns,
  getSearchableColumns,
  getSorter,
} from "../../../utils/tableConfigs/GlobalFunctions";
import {
  COLUMN_WIDTHS,
  TRACKER_DEFAULT_HIDDEN_COLUMNS,
  TRACKER_FIXED_COLUMNS,
  SEARCHABLE_COLUMNS,
  TITLE_MAPPING,
  NO_TIMEPOINT_COLUMNS,
  DOSE_UNITS,
} from "../../../utils/tableConfigs/DosingConstants";
import {
  getCellWidth,
  getCellRenderer,
  getCellProperties,
} from "../../../utils/tableConfigs/DosingTrackerFunctions";
import { Tooltip } from "antd";

export const getColumnConfig = (
  rows: Record<string, unknown>[],
  handleCellClick: (...args: unknown[]) => unknown,
  filteredInfo: Record<string, unknown[] | null>,
  path: string,
  type: string,
) => {
  const originalHeaders = rows.length > 0 ? Object.keys(rows[0]) : [];

  const baseOrder = [
    "subject",
    "site",
    "country",
    "study_status",
    "study_arm_label",
    "total_dosage",
  ];

  const orderedBaseHeaders = baseOrder.filter((header) =>
    originalHeaders.includes(header),
  );

  const remainingHeaders = originalHeaders.filter(
    (header) => !baseOrder.includes(header),
  );

  const headers = [...orderedBaseHeaders, ...remainingHeaders];

  const columns = headers.map((header) => {
    const filters = createFilters(rows, header);
    return {
      title: () => {
        const title = getFormattedTitles(header, TITLE_MAPPING);
        if (header === "total_dosage") {
          return (
            <Tooltip
              title={
                <div style={{ textAlign: "center" }}>
                  Total Dose Administered in {DOSE_UNITS}.
                </div>
              }
            >
              {title}
            </Tooltip>
          );
        }
        return title;
      },
      dataIndex: header,
      key: header,
      sorter: getSorter(header),
      onCell: (record: Record<string, unknown>) => {
        return getCellProperties(record, header, handleCellClick, type);
      },
      render: (text: unknown, record: Record<string, unknown>) => {
        if (text === null) {
          return "-";
        }
        return getCellRenderer(text as any, header, path, type, record);
      },
      filters: filters,
      filteredValue: (() => {
        return filteredInfo[header] || null;
      })(),
      onFilter: (value: unknown, record: Record<string, unknown>) =>
        record[header] === value,
      fixed: getFixedColumns(header, TRACKER_FIXED_COLUMNS),
      hidden: getHiddenColumns(header, TRACKER_DEFAULT_HIDDEN_COLUMNS),
      width: (getCellWidth as any)(header, COLUMN_WIDTHS),
      align: NO_TIMEPOINT_COLUMNS.has(header) ? "left" : "center",
      filterSearch: (getSearchableColumns as any)(header, SEARCHABLE_COLUMNS),
    };
  });

  return columns;
};
